import React, { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';
import theme from '../../../../theme';
import { Card, CardContent, CardHeader, Grid } from '@material-ui/core';
import CircularProgress from '@material-ui/core/CircularProgress';
import { ValidatorForm } from 'react-material-ui-form-validator';
import { ServiceValues } from '../../../../values/ServiceValues';
import { ServiceAxios } from '../../../../services/ServiceEW';
import Button from '@material-ui/core/Button';
import Paper from '@material-ui/core/Paper';
import Table from '@material-ui/core/Table';
import TableHead from '@material-ui/core/TableHead';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import TableBody from '@material-ui/core/TableBody';
import IconButton from '@material-ui/core/IconButton';
import TablePagination from '@material-ui/core/TablePagination';
import DeleteIcon from '@material-ui/icons/Delete';


const useStyles = makeStyles({
  root: {},
  row: {
    display: 'flex',
    alignItems: 'center',
    marginTop: theme.spacing(2)
  },
  spacer: {
    flexGrow: 1
  },
  importButton: {
    marginRight: theme.spacing(1)
  },
  exportButton: {
    marginRight: theme.spacing(1)
  },
  searchInput: {
    marginRight: theme.spacing(1)
  },
  tableWrapper: {
    maxHeight: 300,
    overflow: 'auto',
  },

  autoCompleteStyle: {
  }
});

export default function UsuarioRegisterEmpresas(props) {
  const baseUrl = ServiceValues.base_url_local;
  const timeout = ServiceValues.timeout;
  const api = ServiceAxios(baseUrl, timeout);
  const classes = useStyles();
  const { className, history, usuario, setUsuario, edicao,...rest } = props;
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(100);
  const [usuariosVinculados, setUsuariosVinculados] = useState([]);
  const [empresaSelecionada, setEmpresaSelecionada] = useState();
  const [refreshState, setRefreshState] = useState('');
  const [openAutocomplete, setOpenAutocomplete] = useState(false);
  const [empresas, setEmpresas] = useState([]);
  const loadingEmpresas = openAutocomplete && empresas.length === 0;

  function sleep(delay = 0) {
    return new Promise(resolve => {
      setTimeout(resolve, delay);
    });
  }

  useEffect(() => {
    let active = true;

    if (!loadingEmpresas) {
      return undefined;
    }

    (async () => {
      const params = {
        limit: 5000,
      };
      let dados = await api.get('empresas/', {params: params});
      dados = dados.data.result;

      if (active) {
        setEmpresas(dados);

      }
    })();

    return () => {
      active = false;
    };
  }, [loadingEmpresas]);

  React.useEffect(() => {
    if (!openAutocomplete) {
      setEmpresas([]);
    }
  }, [openAutocomplete]);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = event => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  function aoModificarEmpresa(event, empresa) {
    if(empresa !== undefined){
      setEmpresaSelecionada(empresa);
    }

  }

  function adicionarEmpresa() {
    if(empresaSelecionada !== undefined){
      usuario.empresas.push(empresaSelecionada);
      setUsuario(usuario);
      setEmpresaSelecionada(undefined);
    }
  }

  function removerEmpresa(event, index) {
    if(edicao){
      usuario.empresas[index].idEmpresa = undefined;
      setUsuario(usuario);
      setRefreshState(new Date());
    }
    else{
      usuario.empresas.splice(index, 1);
      setUsuario(usuario);
      setRefreshState((new Date).toString());
    }

  }


  return (
    <div>
      <ValidatorForm
        autoComplete="off"
        onSubmit={adicionarEmpresa}
      >
        <CardHeader
          subheader="Informe os seguintes dados para adicionar um endereço"
          title="Endereços"
        />
        <CardContent>
          <Grid
            container
            spacing={3}
          >
            <Grid
              item
              md={9}
              xs={12}
            >
              <Autocomplete
                size={'small'}
                id="autocomplete_empresa"
                open={openAutocomplete}
                value={empresaSelecionada}
                onOpen={() => {
                  setOpenAutocomplete(true);
                }}
                onClose={() => {
                  setOpenAutocomplete(false);
                }}
                onChange={aoModificarEmpresa}
                getOptionSelected={(option, value) => option.razaoSocial === option.razaoSocial}
                getOptionLabel={option => option.cnpj + ' - ' + option.razaoSocial}
                options={empresas}
                loading={loadingEmpresas}
                renderInput={params => (
                  <TextField
                    {...params}
                    label="Usuários"
                    fullWidth
                    value={empresaSelecionada}
                    variant="outlined"
                    helperText={'Selecione uma empresa no qual deseja conceder acesso a esse usuário e clique no botão adicionar.'}
                    InputProps={{
                      ...params.InputProps,
                      endAdornment: (
                        <React.Fragment>
                          {loadingEmpresas ? <CircularProgress color="inherit" size={20} /> : null}
                          {params.InputProps.endAdornment}
                        </React.Fragment>
                      ),
                    }}
                  />
                )}
              />
            </Grid>
            <Grid
              item
              md={3}
              xs={12}
            >
              <Button
                color="primary"
                fullWidth
                size="large"
                type="submit"
                variant="contained"
              >
                Adicionar
              </Button>
            </Grid>

              <Grid
                item
                md={12}
                xs={12}
              >
                <Paper className={classes.root}>
                  <div className={classes.tableWrapper}>

                    <Table stickyHeader aria-label="sticky table">
                      <TableHead>
                        <TableRow>
                          <TableCell>Nome</TableCell>
                          <TableCell>CPF/CNPJ</TableCell>
                          <TableCell>Ações</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {usuario.empresas.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((empresa, index) => {
                          return (
                            empresa.idEmpresa &&
                            <TableRow hover role="checkbox" tabIndex={-1} key={empresa.idEmpresa}>
                              <TableCell>{empresa.razaoSocial}</TableCell>
                              <TableCell>{empresa.cnpj}</TableCell>
                              <TableCell>
                                <IconButton
                                  aria-label="delete"
                                  className={classes.expand}
                                  onClick={e => removerEmpresa(e, index)}

                                >
                                  <DeleteIcon
                                    fontSize={'small'}
                                    color={'action'}
                                  />
                                </IconButton>
                              </TableCell>
                            </TableRow>
                          );
                        })}
                      </TableBody>
                    </Table>
                  </div>
                  <TablePagination
                    rowsPerPageOptions={[10, 25, 100]}
                    component="div"
                    count={usuario.empresas.length}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    backIconButtonProps={{
                      'aria-label': 'previous page',
                    }}
                    nextIconButtonProps={{
                      'aria-label': 'next page',
                    }}
                    onChangePage={handleChangePage}
                    onChangeRowsPerPage={handleChangeRowsPerPage}
                  />
                </Paper>
              </Grid>
          </Grid>
        </CardContent>

      </ValidatorForm>
    </div>
  );
}
